import React from 'react';
import { FetchedDataParams } from '../../config/endpoints';
import { Compound, Substance } from '../models/Substance';

interface PublicPaginationData<P = {}> {
    pageNumber: number;
    pageSize: number;
    params: Partial<P>;
}

export interface QueryResultParams<T, P = {}> {
    data: T[];
    error: Error | undefined;
    loading: boolean;
    total: number | undefined;
    pageSize: number;
    pageNumber: number;
    totalPages: number | undefined;
    params: P;
    next: () => void;
    prev: () => void;
    cancel: () => void;
    setPageSize: (size: number) => void;
    initial: boolean;
    setPage: (page: number) => void;
    mutate: (
        data: Partial<PublicPaginationData<P>> & { resetData?: boolean },
    ) => void;
    resetData: () => void;
}

export const QueryResult = React.createContext<
    QueryResultParams<Substance | Compound, FetchedDataParams>
>({
    data: [],
    error: undefined,
    loading: false,
    total: undefined,
    pageSize: 25,
    pageNumber: 1,
    totalPages: undefined,
    params: {},
    next: () => {},
    prev: () => {},
    cancel: () => {},
    setPageSize: (size: number) => {},
    initial: true,
    setPage: (page: number) => {},
    mutate: (
        data: Partial<PublicPaginationData> & { resetData?: boolean },
    ) => {},
    resetData: () => {},
});

export const useQueryResult = () => React.useContext(QueryResult);
